module.exports = __webpack_public_path__ + "static/media/step-01.28996b33.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar/img/step-01.png
 ** module id = 2055
 ** module chunks = 0
 **/